// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/my-steam-profil/my-steam-profil/apps/mobile/app/_layout.tsx"); } },
  "./game/[appId].tsx": { enumerable: true, get() { return require("/home/runner/work/my-steam-profil/my-steam-profil/apps/mobile/app/game/[appId].tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/runner/work/my-steam-profil/my-steam-profil/apps/mobile/app/index.tsx"); } },
  "./setup.tsx": { enumerable: true, get() { return require("/home/runner/work/my-steam-profil/my-steam-profil/apps/mobile/app/setup.tsx"); } },
  "./stats.tsx": { enumerable: true, get() { return require("/home/runner/work/my-steam-profil/my-steam-profil/apps/mobile/app/stats.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;